import cartModel from "../components/cart/cartModel";
import quantityPicker from "../components/quantityPicker";

const cart = (() => {
  const SELECTOR_FORM = ".js-cartItems";
  const SELECTOR_ITEM = ".js-lineItem";
  const SELECTOR_LINE_PRICE = ".js-linePrice";
  const SELECTOR_LINE_PRICE_DESKTOP = ".js-linePriceDesktop";
  const SELECTOR_TOTAL_PRICE = ".js-totalPrice";
  const SELECTOR_DROP = ".js-cartItemDrop";
  const SELECTOR_UPDATE_QTY = ".js-cartItemQty";
  const SELECTOR_EMPTY = ".js-cartEmpty";

  function showEmptyCart(data, id) {
    if (!data.items.length) {
      document.querySelector(SELECTOR_EMPTY).classList.remove("hidden");
      document.querySelector(SELECTOR_FORM).classList.add("hidden");
    } else {
      document.querySelector(SELECTOR_EMPTY).classList.add("hidden");
      document.querySelector(SELECTOR_FORM).classList.remove("hidden");
    }
  }

  function updatePrice(data, id) {

    const elLinePrice = document.querySelector(
      `${SELECTOR_LINE_PRICE}[data-id="${id}"]`
    );

    const elLinePriceDesktop = document.querySelector(
      `${SELECTOR_LINE_PRICE_DESKTOP}[data-id="${id}"]`
    );

    const elTotalPrice = document.querySelector(SELECTOR_TOTAL_PRICE);
    const item = data.items.find((item) => {
      return item.id === Number(id);
    });

    elTotalPrice.innerHTML = cartModel.stylePrice(data.total_price);
    item ? (elLinePrice.innerHTML = cartModel.stylePrice(item.line_price)) : "";
    item ? (elLinePriceDesktop.innerHTML = cartModel.stylePrice(item.line_price)) : "";
  }

  function onItemDropClick(ev) {
    ev.preventDefault();
    const id = ev.currentTarget.getAttribute("data-id") || 0;
    const line = parseInt(ev.currentTarget.getAttribute("data-line") || 0, 10);
    const elItem = ev.currentTarget.closest(SELECTOR_ITEM);

    if (!id) return null;

    elItem.style.display = "none";
    cartModel.remove(id, line, true);
  }

  function onItemQtyUpdate(ev) {
    ev.preventDefault();
    const id = ev.currentTarget.getAttribute("data-id") || 0;
    const qty = ev.currentTarget.value;

    if (!id) return null;

    cartModel.update(id, qty, true);
  }

  function bind() {
    Array.prototype.forEach.call(
      document.querySelectorAll(SELECTOR_DROP),
      (el) => {
        el.removeEventListener("click", onItemDropClick);
        el.addEventListener("click", onItemDropClick);
      }
    );
    Array.prototype.forEach.call(
      document.querySelectorAll(SELECTOR_UPDATE_QTY),
      (el) => {
        el.removeEventListener("change", onItemQtyUpdate);
        el.addEventListener("change", onItemQtyUpdate);
      }
    );
  }

  function init() {
    bind();
    quantityPicker.init();
    cartModel.addCallback(updatePrice);
    cartModel.addCallback(showEmptyCart);
  }

  return {
    init,
  };
})();

export default cart;
